module.exports = __webpack_public_path__ + "img/season-3.798b47a3.png";